export interface BaseImageResponse {
  originalUrl: string;
  originalWidth: number;
  originalHeight: number;
  resizedUrl: string;
  resizedWidth: number;
  resizedHeight: number;
}
export interface BaseResponse<T> {
  status: number; // HTTP 상태 코드
  resultMsg: string; // 응답 메시지
  divisionCode: null; // 응답 메시지
  data: T; // 제네릭 타입의 데이터
}

export interface BasePaginationResponse<T> {
  content: T[];
  totalElements: number; // 전체 요소 수
  totalPages: number; // 전체 페이지 수
  currentPage: number; // 현재 페이지
  pageSize: number; // 페이지 크기
}

export enum SaleStatus {
  NOT_REGISTERED = 'NOT_REGISTERED', // 미등록
  ON_SALE = 'ON_SALE', // 판매 중
  RESERVED = 'RESERVED', // 판매 예약
  FINISHED = 'FINISHED', // 판매 완료
}
